module.exports = __webpack_public_path__ + "img/base_patrimoine_pont.5dec5e35.svg";